import { IAppInfo } from '@common/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type State = {
  app?: IAppInfo;
  currentLocation: any;
  locationError: any;
  error: Record<string, any>;
};

const initialState: State = {
  currentLocation: null,
  locationError: null,
  error: {
    messages: [],
    isError: false,
  },
};

const appSlice = createSlice({
  name: 'appInfo',
  initialState: initialState,
  reducers: {
    loadApp: (state: State, action: PayloadAction<IAppInfo>) => {
      if (action.payload) {
        state.app = action.payload;
      }
    },
    checkLocationSuccess: (state: State, action: PayloadAction<object>) => {
      if (!action.payload) return;

      state.currentLocation = action.payload;
    },
    checkLocationError: (state: State, action: PayloadAction<any>) => {
      state.locationError = action.payload;
    },
    setError: (state: State, action: PayloadAction<any>) => {
      state.error.isError = true;
      state.error.messages = [...state.error.messages, action.payload];
    },
    resetError: (state: State) => {
      state.error = initialState.error;
    },
  },
});

export const {
  loadApp,
  checkLocationSuccess,
  checkLocationError,
  setError,
  resetError,
} = appSlice.actions;
export default appSlice.reducer;
